'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Modal } from '@common/components';
import { useShallow } from 'zustand/react/shallow';
import { ENV, ROUTES, SEARCH_PARAMS } from '@/constants';
import { useAccessToken } from '@/hooks/useAccessToken';
import { KB_PAY_CUSTOM_SCHEME } from '@/modules/kb-pay';
import { useGlobalStore } from '@/stores/GlobalStore';
export const WelloWebLinkModal = () => {
  const $ = _c(22);
  const {
    accessToken,
    refreshToken
  } = useAccessToken();
  const [welloWebLinkModalProps, setWelloWebLinkModalProps] = useGlobalStore(useShallow(_temp));
  let t0;
  if ($[0] !== welloWebLinkModalProps) {
    t0 = welloWebLinkModalProps || {};
    $[0] = welloWebLinkModalProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    descriptions,
    link
  } = t0;
  let t1;
  if ($[2] !== setWelloWebLinkModalProps) {
    t1 = () => setWelloWebLinkModalProps(null);
    $[2] = setWelloWebLinkModalProps;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const closeModal = t1;
  const t2 = !!welloWebLinkModalProps;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h2 className="font-700 text-Gray-black typo-body1">웰로 웹페이지에서<br />이용해 주세요</h2>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== descriptions) {
    t4 = <p className="pb-16 pt-8 text-Gray-700 typo-body3">{descriptions}</p>;
    $[5] = descriptions;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== closeModal) {
    t5 = <Button className="flex-1" dimensions="H48" theme="primary-line" onClick={closeModal}>뒤로가기</Button>;
    $[7] = closeModal;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== accessToken || $[10] !== closeModal || $[11] !== link || $[12] !== refreshToken) {
    t6 = <Button className="flex-1" dimensions="H48" onClick={() => {
      const welloDomain = ENV.NEXT_PUBLIC_DOMAIN;
      if (!link) {
        return;
      }
      const linkUrl = new URL(link, location.origin);
      if (!accessToken || !refreshToken) {
        return;
      }
      const redirectSearchParams = {};
      linkUrl.searchParams.forEach((value, key) => {
        redirectSearchParams[key] = value;
      });
      window.location.href = `${KB_PAY_CUSTOM_SCHEME.EXTERNAL_PREFIX}${welloDomain}${ROUTES.CROSS_DOMAIN_CALLBACK.withSearchParams({
        searchParams: {
          accessToken,
          refreshToken,
          [SEARCH_PARAMS.REDIRECT]: linkUrl.pathname,
          [SEARCH_PARAMS.REDIRECT_SEARCH_PARAMS]: JSON.stringify(redirectSearchParams)
        }
      })}`;
      closeModal();
    }}>이동</Button>;
    $[9] = accessToken;
    $[10] = closeModal;
    $[11] = link;
    $[12] = refreshToken;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t5 || $[15] !== t6) {
    t7 = <footer className="flex gap-8">{t5}{t6}</footer>;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== closeModal || $[18] !== t2 || $[19] !== t4 || $[20] !== t7) {
    t8 = <Modal opened={t2} onClose={closeModal}>{t3}{t4}{t7}</Modal>;
    $[17] = closeModal;
    $[18] = t2;
    $[19] = t4;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};
function _temp(state) {
  return [state.welloWebLinkModalProps, state.setWelloWebLinkModalProps];
}